 $(document).ready(function() {
    $('body').on('click', '.pinDrawer', function() {
      console.log('clickkk');
        var $this = $(this);
        var originalTexts = $this.text();

        $this.text('Loading...').prop('disabled', true);

        setTimeout(function() {
            $this.text(originalTexts).prop('disabled', false);
        }, 1200);

        
      var inputValuee = $("#inputField.pincheck").val();
      if (!inputValuee) {
        $('#inputField.pincheck').addClass('error').val('').attr('placeholder', 'Please enter a valid pincode first');
        return;
      }
      var api_key1 = "2d2170d89292739548d751e68cbfe2bd9d0ad16f";
      //var apicall1 = "https://obscure-ridge-95292.herokuapp.com/delivery_api/lakmedelivery_api.php?api_key=" + api_key1 + "&pincodeTocheck=" + inputValuee;
      var apicall1 = "https://lakmedelhivery.ensdevops.com/pincode?pincode="+inputValuee;
      console.log(apicall1, "apicall");

      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          var json_data = JSON.parse(this.responseText);
          var delivery_codess = json_data.delivery_codes;

          console.log(delivery_codess);
          if (json_data == 1) {
            $('#inputField.pincheck').removeClass('error').val('Estimated delivery in 2-5 days').attr('readonly', true).addClass('border-none');
            $('.pinDrawer').hide();
            $('.edit_pincode').html(inputValuee + " <svg width='16' height='15' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M13.2875 2.4875C13.7375 2.9375 13.7375 3.6125 13.2875 4.0625L4.85 12.5H1.25V8.9L9.6875 0.4625C10.1375 0.0125 10.8125 0.0125 11.2625 0.4625L13.2875 2.4875ZM12.5 3.275L10.475 1.25L8.7875 2.9375L10.8125 4.9625L12.5 3.275ZM2.375 9.35V11.375H4.4L10.025 5.75L8 3.725L2.375 9.35ZM0.125 14.75V13.625H15.875V14.75H0.125Z' fill='black'/></svg>").show();
          } else {
            console.log("works not");
            $('#inputField.pincheck').addClass('error').val('').attr('placeholder', 'Invalid Pincode, please enter a valid Pincode');
          }
        }
      };
      xhttp.open("GET", apicall1, true);
      xhttp.send();
    });

    $('body').on('click', '.edit_pincode', function() {
      $('#inputField.pincheck').removeAttr('readonly').val('').attr('placeholder', 'Enter Pin Code Here').removeClass('border-none');
      $('.edit_pincode').hide();
      $('.pinDrawer').show();
    });

    $('#inputField.pincheck').focus(function() {
      $(this).removeClass('error').attr('placeholder', 'Enter Pin Code Here');
    });
  });